import { ThemeParameters, RuntimeThemeParameters } from '../../types';
import { graphOverviewAxisFilter } from './';

export const graphOverviewFilterFill = (
  theme: ThemeParameters,
  parameters: RuntimeThemeParameters
) => {
  const overviewAxisFilter = graphOverviewAxisFilter(theme, parameters);
  return {
    fillColor: overviewAxisFilter.fillColor,
    fillTransparency: overviewAxisFilter.fillTransparency, // TODO: update doc fillTransparency vs transparency
  };
};
